import antd from 'ant-design-vue/es/locale-provider/es_ES';
import dayjsLocale from 'dayjs/locale/es';
import momentEnCA from 'moment/dist/locale/en-ca';
import data from '../json/es.json';

const components = {
  antLocale: antd,
  momentName: 'eu',
  momentLocale: momentEnCA,
  dayjsName: 'es',
  dayjsLocale
};

export default {
  ...components,
  ...data
};
